module.exports = __webpack_public_path__ + "img/01.c131c26c.jpg";